import { render, staticRenderFns } from "./ModalTambahKategori.vue?vue&type=template&id=10156a43&scoped=true&"
import script from "./ModalTambahKategori.vue?vue&type=script&lang=js&"
export * from "./ModalTambahKategori.vue?vue&type=script&lang=js&"
import style0 from "./ModalTambahKategori.vue?vue&type=style&index=0&id=10156a43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10156a43",
  null
  
)

export default component.exports